import apiClient from './apiClient';

export const activityService = {
  // Get all activities
  getAllActivities: async (params = {}) => {
    try {
      const response = await apiClient.get('/activities', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single activity
  getActivity: async (id) => {
    try {
      const response = await apiClient.get(`/activities/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new activity
  createActivity: async (activityData) => {
    try {
      const response = await apiClient.post('/activities', activityData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update activity
  updateActivity: async (id, activityData) => {
    try {
      const response = await apiClient.put(`/activities/${id}`, activityData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete activity
  deleteActivity: async (id) => {
    try {
      const response = await apiClient.delete(`/activities/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get activity statistics
  getActivityStats: async () => {
    try {
      const response = await apiClient.get('/activities-data/stats');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Toggle activity status
  toggleActivityStatus: async (id) => {
    try {
      const response = await apiClient.post(`/activities/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
}; 